import { Row, Typography } from "@commonlibs";
import clsx from "clsx";
import { spacing } from "ui/config/theme/spacing/spacing";
import GoBackButton from "../../navigation/GoBackButton/GoBackButton";
import { MainScaffoldRoot } from "./MainScaffold.styles";
import { MainScaffoldProps } from "./MainScaffold.types";

const MainScaffold = ({ children, className, title, back, ...rest }: MainScaffoldProps) => {
    const hasHeader = children.header || title || back;
    return (
        <MainScaffoldRoot className={clsx("main-scaffold", className)} {...rest}>
            <>
                {hasHeader && (
                    <Row justifyContent="space-between" alignItems="center" wrap wrapGap={spacing["4"]}>
                        <Row alignItems="center" gap={spacing[4]} css={{ maxWidth: "100%" }}>
                            {back && <GoBackButton css={{ minWidth: "auto" }} variant="secondary" />}
                            {title && (
                                <Typography variant="h4Strong" singleLine>
                                    {title}
                                </Typography>
                            )}
                        </Row>
                        {children.header}
                    </Row>
                )}
                {children.content}
                {children.footer}
            </>
        </MainScaffoldRoot>
    );
};

export default MainScaffold;
